import promotion from '@resources/js/components/promotion'
import inViewport from '@resources/js/helpers/inViewport'
import MapView from '@resources/js/maps/MapView'
import MapHotelsStore from '@resources/js/maps/MapStores/MapHotelsStore'

import FormView from '@resources/js/components/form/FormView'
import FormStore from '@resources/js/components/form/FormStore'
import FormPresenter from '@resources/js/components/form/FormPresenter'
import generateBcomUrl from '@resources/js/helpers/generateBcomUrl'
import { format } from '@formkit/tempo'

promotion({
    links: {
        active: true
    },
    backbtn: {
        active: true
    },
    tab_change: {
        active: true
    },
    popup: {
        active: true
    },
    housesitter: {
        active: true
    }
})

// map
inViewport("#mapbox", () => {
    const map = new MapView({ zoom: 12 })
    const mapHotelsStore = new MapHotelsStore()
    const data = mapHotelsStore.getData()
    map.addMarkers(data)
    map.fitByCoords(mapHotelsStore.getCoordinates())
})


// main form
const mainFormElement = document.querySelector('.js-form')

const formStore = new FormStore()
const mainFormView = new FormView(mainFormElement)
const mainFormPresenter = new FormPresenter(mainFormView, formStore)

const handleFormSubmit = (formData) => {
    const url = generateBcomUrl({
        type: 'calendar-form',
        dates: {
            checkIn: format(formData.checkIn, 'YYYY MM DD'),
            checkOut: format(formData.checkOut, 'YYYY MM DD'),
        },
    })

    window.open(url, '_blank')
}

mainFormPresenter.on('form-submit', handleFormSubmit)

